import { render, staticRenderFns } from "./StockConsumptionAjurNumber.vue?vue&type=template&id=11d96973&scoped=true&"
import script from "./StockConsumptionAjurNumber.vue?vue&type=script&lang=js&"
export * from "./StockConsumptionAjurNumber.vue?vue&type=script&lang=js&"
import style0 from "./StockConsumptionAjurNumber.vue?vue&type=style&index=0&id=11d96973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d96973",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardTitle,VCol,VContainer,VDataTable,VRow})
